export default __webpack_public_path__ + "static/media/27.60eb0395.svg";